import React from 'react';
import {Button, ButtonGroup, Dropdown, DropdownButton} from 'react-bootstrap';
import Block from '../Block';
import Icon from '../Icon';
import Table from '../tables/Table';
import useCustomTable from '../tables/useCustomTable';
import useActionConfirmation from "../useActionConfirmation";
import {useTranslation} from "react-i18next";


const AwsCredsTable = ({creds, onDelete}) => {
  const { t } = useTranslation();
  const {Confirmation, confirmationProps, confirm} = useActionConfirmation()

  const columns = [{
    Header: 'Id',
    accessor: 'access_key_id',
  },{
    Header: 'Created at',
    accessor: 'create_date',
  },{
    Header: 'Status',
    accessor: 'status'
  },{
    Header: '',
    accessor: (row) => row.access_key_id,
    id: 'action',
    Cell: (cell) => <DropdownButton
        as={ButtonGroup}
        variant="light"
        title={"actions"}
      >
        <Dropdown.Item onClick={() => confirm( () => {
          onDelete(cell)
        }, t("awsCredentials.delete_value"))}>
          <Icon icon='trash' text={t("delete")} />
        </Dropdown.Item>
      </DropdownButton>
  }]

  const {
    tableProps
  } = useCustomTable({
    sortable: false,
    paginate: false,
    filterable: false,
  })

  return (
    <>
      <Block>
        <Table data={creds} columns={columns} {...tableProps} />
      </Block>
      <Confirmation placeholder="Please enter value to confirm" {...confirmationProps} deletion >
      <>
        {t("awsCredentials.validation_message")} : <strong>{t("awsCredentials.delete_value")}</strong>
        <hr/>
      </>
      </Confirmation>
    </>
   );
}

export default AwsCredsTable;
